module.exports = __webpack_public_path__ + "static/media/contact-page-location.de7d15f0.svg";